import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'integerPart'
})
export class IntegerPart implements PipeTransform {

  integerPart = '';

  transform(balance: string) {

    if (balance) {
      const balanceArray: string[] = balance.split('.');
      this.integerPart = balanceArray[0];
    }

    return this.integerPart;
  }
}
